// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2U-He","name":"ConsentHeader_name__2qeQu","birthday":"ConsentHeader_birthday__3pu05","skeleton":"ConsentHeader_skeleton__HgMh5"};